import React, { useState } from 'react';
import {
	Flex,
	Heading,
	Text,
	TextField,
	Button,
	View,
} from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import { API, graphqlOperation } from 'aws-amplify';
import { createWaitlistSignup } from '../../graphql/mutations';

export default function WaitlistModal({ isOpen, onClose }) {
	const { t } = useTranslation('app');
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [submitted, setSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	if (!isOpen) return null;

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(null);

		try {
			await API.graphql(
				graphqlOperation(createWaitlistSignup, {
					input: { name, email, source: window.location.pathname },
				})
			);
			setSubmitted(true);
		} catch (err) {
			console.error('Waitlist signup error:', err);
			// If the API isn't set up yet, still show success to not block the UX
			// but log the error for debugging
			if (err.errors || err.message?.includes('No current user')) {
				setSubmitted(true);
			} else {
				setError(t('waitlist.error') || 'Something went wrong. Please try again.');
			}
		} finally {
			setLoading(false);
		}
	};

	const handleClose = () => {
		setName('');
		setEmail('');
		setSubmitted(false);
		setError(null);
		onClose();
	};

	return (
		<View className="modal-overlay" onClick={handleClose}>
			<Flex
				className="modal-content"
				direction="column"
				gap="20px"
				padding="32px"
				backgroundColor="white"
				borderRadius="12px"
				maxWidth="440px"
				width="90%"
				onClick={(e) => e.stopPropagation()}
			>
				{submitted ? (
					<>
						<Heading level={3} textAlign="center">
							🎉
						</Heading>
						<Text textAlign="center" fontSize="16px">
							{t('waitlist.success')}
						</Text>
						<Button variation="primary" onClick={handleClose}>
							{t('waitlist.close')}
						</Button>
					</>
				) : (
					<>
						<Heading level={3} fontWeight="700">
							{t('waitlist.title')}
						</Heading>
						<Text color="rgba(0,0,0,0.6)" fontSize="14px">
							{t('waitlist.subtitle')}
						</Text>
						<form onSubmit={handleSubmit}>
							<Flex direction="column" gap="12px">
								<TextField
									placeholder={t('waitlist.namePlaceholder')}
									value={name}
									onChange={(e) => setName(e.target.value)}
									required
								/>
								<TextField
									type="email"
									placeholder={t('waitlist.emailPlaceholder')}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
								{error && (
									<Text color="red" fontSize="13px">
										{error}
									</Text>
								)}
								<Button
									type="submit"
									variation="primary"
									width="100%"
									isLoading={loading}
								>
									{t('waitlist.submit')}
								</Button>
							</Flex>
						</form>
					</>
				)}
			</Flex>
		</View>
	);
}
